import React, { createContext, useState } from "react";
import PropTypes from "prop-types";

export const AttendanceRequestContext = createContext();

export const AttendanceRequest = ({ children }) => {
    const [attendanceRequestCount, setAttendanceRequestCount] = useState(null);
    return (
        <AttendanceRequestContext.Provider value={{attendanceRequestCount, setAttendanceRequestCount }}>
            {children}
        </AttendanceRequestContext.Provider>
    );
};

AttendanceRequest.propTypes = {
    children : PropTypes.node.isRequired
};